import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';

/**
 * Copyright 2023, IntraLinks, Inc, All rights reserved.
 */

/* eslint-disable */

var isLoaded = false;
var gainSightLoaded = 'gainSightLoaded';
var setGlobalContext = function setGlobalContext(globalContextDetail) {
  aptrinsic('set', 'globalContext', globalContextDetail);
};
var updateGlobalContext = function updateGlobalContext(globalContextDetail) {
  aptrinsic('set', 'globalContext', globalContextDetail);
};
var removeGlobalContext = function removeGlobalContext(globalContextDetail) {
  aptrinsic('remove', 'globalContext', globalContextDetail);
};
var loadScript = function loadScript(analyticsFileSrc) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.type = "text/javascript";
    script.async = true;
    script.src = analyticsFileSrc || "https://cdn.jsdelivr.net/gh/nkaranjit/analytic/analytic.js";
    script.id = 'gainsight';

    // Append the script to the DOM
    var el = document.getElementsByTagName('script')[0];
    el.parentNode.insertBefore(script, el);

    // Resolve the promise once the script is loaded
    script.addEventListener('load', function () {
      isLoaded = true;
      resolve(script);
    });

    // Catch any errors while loading the script
    script.addEventListener('error', function () {
      reject(new Error('gainsight failed to load.'));
    });
  });
};
var loadGainSight = function loadGainSight(productKey, userDetail, accountDetail, analyticsFileSrc) {
  return new Promise(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
      var gainSightCustomEvent;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (isLoaded) {
              _context.next = 16;
              break;
            }
            _context.prev = 1;
            _context.next = 4;
            return loadScript(analyticsFileSrc);
          case 4:
            window.aptrinsic('config', 'tagKey', productKey);
            if (userDetail && accountDetail) {
              aptrinsic("identify", {
                //User Fields
                "id": userDetail.id,
                // Required for logged in app users
                "email": userDetail.email,
                "firstName": userDetail.firstName,
                "lastName": userDetail.lastName
              }, {
                //Account Fields
                "id": accountDetail.id,
                //Required
                "name": accountDetail.name,
                "Program": accountDetail.program // flat custom attributes
              });
            } else if (userDetail) {
              aptrinsic("identify", {
                //User Fields
                "id": userDetail.id,
                "email": userDetail.email
              });
            }
            resolve();
            gainSightCustomEvent = new Event(gainSightLoaded);
            window.dispatchEvent(gainSightCustomEvent);
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            reject(_context.t0);
          case 14:
            _context.next = 17;
            break;
          case 16:
            resolve();
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 11]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

export { gainSightLoaded, loadGainSight, removeGlobalContext, setGlobalContext, updateGlobalContext };
